import { AdminLayout, useSource, useTranslation } from "@opendash/core";
import { AdminToolbar, FixedDescription } from "@opendash/ui";
import { Card, Empty } from "antd";
import React, { useMemo } from "react";
import { FileDescription, useSourceFiles } from "../../features/knowledge";

export default () => {
  const t = useTranslation();
  const [source] = useSource();
  const { media } = useSourceFiles(source?.id);

  const fileList = useMemo(
    () =>
      media.map((file) => <FileDescription fileData={file} key={file.id} />),
    [media]
  );

  return (
    <AdminLayout>
      <AdminToolbar
        title={t("maintenance:knowledge.overview.title", {
          source: source.name,
        })}
      />
      <Card>
        <FixedDescription children={fileList} />
        {fileList?.length === 0 && <Empty />}
      </Card>
    </AdminLayout>
  );
};
